import ModalEventController from './modal_event_controller'
import { oneLineTrim } from 'common-tags'

export default class extends ModalEventController {
  static values = {
    url: String,
    expiry: Number,
    title: String,
    contentType: String
  }

  expiredBody = "The attachment's URL has expired. <br>Please refresh this page to generate a new URL."
  unsupportedBody = `
    The file type is not supported. <br>
    Please <a target="_blank" rel="noreferrer" href="${this.urlValue}">download</a> the attachment instead.
  `

  connect () {
    this.viewed = false
    this.expired = false

    setTimeout(() => {
      this.expired = true
    }, this.expiryValue * 1000)
  }

  view (event) {
    event.preventDefault()

    if (!this.expired && !this.viewed) this.viewed = true

    const modalContent = {
      header: `<h3>${this.titleValue}</h3>`,
      body: this._createBody()
    }

    this.dispatchShowModalEvent(modalContent)
  }

  _createBody () {
    if (this.viewed || !this.expired) {
      if (this._isOffice()) return this._generateViewerIframe()
      if (this._isPdf()) return this._createIframe(this.urlValue)
      if (this._isImage()) return this._createImageElement()
    } else {
      return this._createInvalidContent(this.expiredBody)
    }

    return this._createInvalidContent(this.unsupportedBody)
  }

  _isOffice () {
    const allowedTypes = new RegExp(oneLineTrim`
      ^(application\/(msword|vnd.(ms-excel|ms-powerpoint)|vnd.openxmlformats-officedocument.(
        wordprocessingml.document|spreadsheetml.sheet|presentationml.presentation
      )))$
    `)

    return allowedTypes.test(this.contentTypeValue)
  }

  _isPdf () {
    return /^application\/pdf$/.test(this.contentTypeValue)
  }

  _isImage () {
    return /^image\/(jpeg|png|bmp)$/.test(this.contentTypeValue)
  }

  _generateViewerIframe () {
    const attachmentUrl = encodeURIComponent(this.urlValue)

    const office = 'https://view.officeapps.live.com/op/view.aspx?src='
    // const google = 'https://docs.google.com/viewer?url='
    const embedded = '&embedded=true'

    const url = office + attachmentUrl + embedded
    return this._createIframe(url)
  }

  _createIframe (url) {
    return `<iframe src="${url}"></iframe>`
  }

  _createImageElement () {
    return `<img src="${this.urlValue}"/>`
  }

  _createInvalidContent (body) {
    return `<p class="invalid-content">${body}</p>`
  }
}
